var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHot = function SvgHot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5C29",
    d: "M3.543 6.95v3.069H2.521v2.727h1.022v2.046h1.023v1.022H3.543v.682h9.546v-.682h1.022V13.77h1.364V8.314h-1.193V7.292h-1.875V5.246h-1.023V3.201h-1.023V1.496H9.34v3.75H8.316V2.86H7.293v1.364H6.27v3.75H4.566V6.95z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7A600",
    d: "M5.248 14.791H6.27v1.364h6.137v-2.386h1.022v-1.023h-1.022v-1.023h-1.023V8.996H10.36v2.045H9.338V9.337H8.316v1.023H7.293v1.363H6.27v1.364H5.248z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.361 12.746H8.316v2.046H7.293v1.023h4.09v-2.046h-1.022z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5C29",
    d: "M4.225 4.223h.682v.682h-.682zM13.771 4.223h.682v2.045h-.682z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7A600",
    d: "M7.634 6.269h.682v2.045h-.682zM12.407 8.314h.682v.682h-.682z"
  })));
};
export default SvgHot;